AoPS.Utils.initKeyChain(AoPS, "Ebooks", "Views", "Book");

AoPS.Ebooks.Views.Book = (function (EbkVBook) {
	// Dependencies
	var Feed = AoPS.Feed;
	var EbkVBase = AoPS.Ebooks.Views.Base;
	var EbkVSearch = AoPS.Ebooks.Views.Search;
	var EbkVToc = AoPS.Ebooks.Views.Toc;
	var EbkVSec = AoPS.Ebooks.Views.Section;

	EbkVBook.Main = EbkVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-book-main");

			this.full = options.full !== false;

			this.url_table = options.url_table;
			this.stay_attr = options.stay_attr;

			this.body_view_cache = {};

			var master = this.model.get("master");
			this.listenTo(master, "change:is_offline", this.onOfflineChange);

			this.createSubviews();

			this.model.requestLoad(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}
				this.render();
			}, this);

			this.renderLoading();
		},

		createSubviews: function () {
			if (this.full) {
				this.header_view_obj = new EbkVBook.Header({
					model: this.model,
					url_table: this.url_table,
					stay_attr: this.stay_attr,
				});
				this.addSubviewToLocation(this.header_view_obj, "@header");

				this.toc_bar_view_obj = new EbkVToc.Bar({
					model: this.model,
					link_size: 5,
				});
				this.addSubviewToLocation(this.toc_bar_view_obj, "@toc");
			} else {
				this.header_view_obj = new EbkVBook.FakeHeader({
					model: this.model,
					url_table: this.url_table,
					stay_attr: this.stay_attr,
				});
				this.addSubviewToLocation(this.header_view_obj, "@header");
			}
		},

		showSection: function (model, details) {
			this.model.requestLoad(function (ok) {
				if (!ok) {
					return;
				}

				// No ToC for non-full views
				if (this.full) {
					this.toc_bar_view_obj.setCurrentSection(model);
				}
				this.header_view_obj.setCurrentSection(model);

				var body_view_obj = this.getOrCreateBody(model);
				this.showBody(body_view_obj);
				body_view_obj.showObject(details);
			}, this);
		},

		showError: function (text) {
			this.showHtmlAsBody(
				this.getErrorBox({
					error_msg: text,
					footer:
						"Please use the bar on the left to return to reading the book.",
				})
			);
		},

		// Internal helper functions

		getOrCreateBody: function (model) {
			var body_view_obj = this.body_view_cache[model.id];
			if (!body_view_obj) {
				body_view_obj = new EbkVSec.Main({
					model: model,
					url_table: this.url_table,
					stay_attr: this.stay_attr,
					full: this.full,
				});
				this.body_view_cache[model.id] = body_view_obj;
			}
			return body_view_obj;
		},

		showBody: function (view_obj) {
			this.current_body && this.current_body.$el.detach();
			this.$(".ebk-section-container").empty().append(view_obj.$el);
			this.current_body = view_obj;
			view_obj.trigger("show");
		},

		showHtmlAsBody: function (html) {
			this.current_body && this.current_body.$el.detach();
			this.$(".ebk-section-container").html(html);
			this.current_body = null;
		},

		onOfflineChange: function (master_model, is_offline) {
			this.$el.toggleClass("ebk-offline-mode", !!is_offline);
		},
	});

	EbkVBook.Header = EbkVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-book-header");

			this.section_model = null;
			this.url_table = options.url_table;
			this.stay_attr = options.stay_attr;
			this.is_free_preview = options.is_free_preview;

			var master = this.model.get("master");
			this.listenTo(master, "change:is_offline", this.onOfflineChange);

			this.createSubviews();
			this.render();
		},

		events: {
			"click .ebk--fullscreen": "onFullscreen", // Unused, but may as well leave this
			"click .ebk--offline": "onOfflineClick", // Unused, but may as well leave this
		},

		setCurrentSection: function (model) {
			this.section_model && this.stopListening(this.section_model);
			this.section_model = model;
			this.listenTo(
				this.section_model,
				"change:alcumus_subject_id change:alcumus_topic_id",
				this.render
			);
			this.render();
		},

		createSubviews: function () {
			this.clearLocation("@search");
			var search = new EbkVSearch.SearchInput({
				model: this.model,
				is_free_preview: this.is_free_preview,
			});
			this.addSubviewToLocation(search, "@search");
		},

		getContext: function () {
			var section = this.section_model;
			var context = {
				stay_attr: this.stay_attr,
				has_feed: !!Feed,
				alcumus_url: section && section.getAlcumusUrl(),
				book_id: this.model.id,
				index_url: this.url_table ? this.url_table.getUrl("index") : "#",
				cover_url: this.model.getCoverUrl(),
				chapter_title: "",
				chapter_title_simple: "",
				section_title: "",
				section_title_simple: "",
			};

			if (this.model.get("master").get("is_embedded")) {
				delete context.alcumus_url;
			}

			var chapter;
			if (section) {
				chapter = section.get("chapter");
				context.chapter_title = chapter && chapter.getNumberTitle({full: true});
				context.chapter_title_simple = chapter && chapter.get("title_html");
				context.section_title = section.getNumberTitle();
				context.section_title_simple = section.get("title_html");
			}

			return context;
		},

		postRender: function () {
			this.setupBookNavigation();
			this.finishFeedButtons();
			this.doFreePreviewMangling();
		},

		// Note this is not the only place where is_free_preview is processed;
		// this just takes care of miscellaneous remaining steps.
		doFreePreviewMangling: function () {
			if (!this.is_free_preview) {
				return;
			}
			var book = this.model;

			function showCoverPreviewModal() {
				EbkVBase.showFreePreviewModal("preview-cover-navigation", book);
			}
			this.$(".ebk--cover-image a")
				.removeAttr("href")
				.addClass("ebk-pointer")
				.click(showCoverPreviewModal);
		},

		setupBookNavigation: function () {
			var book = this.model;
			var section = this.section_model;

			function showPreviewModal() {
				EbkVBase.showFreePreviewModal("preview-header-navigation", book);
			}

			function setupButton(el, type, dir) {
				var link_id = section && section.getRelativeSectionId(type, dir);
				var link_code = link_id && book.getFragmentCodeFromId(link_id);

				if (this.is_free_preview) {
					el.find("a")
						.removeAttr("href")
						.attr(
							"title",
							"This is a navigation button in the full ebook. The link is disabled in the preview."
						)
						.click(showPreviewModal);
					el.show();
				} else if (!link_id) {
					el.find("a").attr("href", "#");
					el.hide();
				} else {
					el.find("a").attr(
						"href",
						this.url_table.getUrl("section", link_code)
					);
					el.show();
				}
			}

			var setupButtonBound = _.bind(setupButton, this);
			setupButtonBound(this.$(".ebk--prev-chapter"), "chapter", -1);
			setupButtonBound(this.$(".ebk--next-chapter"), "chapter", 1);
			setupButtonBound(this.$(".ebk--prev-section"), "section", -1);
			setupButtonBound(this.$(".ebk--next-section"), "section", 1);
		},

		finishFeedButtons: function () {
			var book = this.model;
			var section = this.section_model;
			if (!section || !Feed) {
				this.$(".ebk--community").hide();
				this.$(".ebk--new-topic").hide();
				return;
			}

			function showPreviewModal() {
				EbkVBase.showFreePreviewModal("preview-community-section", book);
			}
			if (this.is_free_preview) {
				this.$(".ebk--community, .ebk--new-topic").click(showPreviewModal);
				return;
			}

			var data = section.getFeedData(this.url_table);

			Feed.buildOpenFeedButton({
				$button: this.$(".ebk--community"),
				category_id: data.category_id,
				tag_text: data.main_url,
				subtitle: data.subtitle,
			});

			Feed.buildNewTopicButton({
				$button: this.$(".ebk--new-topic"),
				category_id: data.category_id,
				tags: data.tags,
				linked_tag: data.tags[data.tags.length - 1],
				target_url: data.main_url,
				target_text: data.subtitle,
				subtitle: data.subtitle,
			});
		},

		onFullscreen: function () {
			if ($("body").hasClass("fullscreen")) {
				$("body").removeClass("fullscreen");
				this.$(".ebk--fullscreen span.aops-font").text("P");
			} else {
				$("body").addClass("fullscreen");
				this.$(".ebk--fullscreen span.aops-font").text("s");
			}
		},

		onOfflineClick: function () {
			var master = this.model.get("master");
			master.set("is_offline", !master.get("is_offline"));
		},

		onOfflineChange: function (master_model, is_offline) {
			EbkVBase.enableHrefs(this.$el, !is_offline);
		},
	});

	EbkVBook.FakeHeader = EbkVBase.BaseView.extend({
		initialize: function (options) {
			this.setTemplateAndUseRootEl("ebk-tpl-book-fake-header");

			this.render();
		},

		setCurrentSection: function (model) {
			this.section_model && this.stopListening(this.section_model);
			this.section_model = model;
			this.listenTo(
				this.section_model,
				"change:alcumus_subject_id change:alcumus_topic_id",
				this.render
			);
			this.render();
		},

		getContext: function () {
			var section = this.section_model;
			var context = {
				cover_url: this.model.getCoverUrl(),
			};

			if (this.model.get("master").get("is_embedded")) {
				delete context.alcumus_url;
			}

			if (section) {
				var chapter = section.get("chapter");
				context.chapter_title = chapter && chapter.getNumberTitle({full: true});
			}

			return context;
		},
	});

	EbkVBook.FreePreviewMain = EbkVBase.BaseView.extend({
		initialize: function () {
			this.setTemplateAndUseRootEl("ebk-tpl-free-preview-main");

			this.model.loadFreePreview(function (ok, data) {
				if (!ok) {
					return this.renderError(data);
				}

				this.section_model = data;
				if (!this.section_model) {
					// TODO
					this.$el.text("This book does not have a freely available preview.");
					return;
				}

				this.header_view = new EbkVBook.Header({
					model: this.model,
					is_free_preview: true,
				});
				this.header_view.setCurrentSection(this.section_model);
				this.addSubviewToLocation(this.header_view, "@header");

				this.toc_bar_view_obj = new EbkVToc.Bar({
					model: this.model,
					link_size: 5,
					is_free_preview: true,
				});
				this.toc_bar_view_obj.setCurrentSection(this.section_model);
				this.addSubviewToLocation(this.toc_bar_view_obj, "@toc");

				this.body_view = new EbkVSec.Main({
					model: this.section_model,
					is_free_preview: true,
					full: true,
				});
				this.addSubviewToLocation(this.body_view, "@body");

				this.render();
			}, this);

			this.renderLoading();
		},
	});

	return EbkVBook;
})(AoPS.Ebooks.Views.Book);
